exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer {\r\n  background-color: #242a2c;\r\n  color: #687579;\r\n}\r\n\r\n.footer .contact-infos {\r\n  width: 300px;\r\n}\r\n\r\n.footer .wechat {\r\n  width: 100px;\r\n  height: 100px;\r\n  padding: 10px;\r\n}\r\n\r\n.footer .social {\r\n  width: 25px;\r\n  height: 25px;\r\n  border-radius: 15%;\r\n  background-color: #687579;\r\n  color: #f1f1f1;\r\n  display: inline-block;\r\n  -webkit-box-shadow: 0px 4px 8px 0px #f1f1f1;\r\n  box-shadow: 2px 4px 8px 0px #f1f1f1;\r\n  margin: 1rem 0.5rem;\r\n}\r\n\r\n.footer .social a,\r\n.footer .social a:link {\r\n  color: #f1f1f1;\r\n}\r\n\r\n.footer .social:hover {\r\n  -webkit-transform: scale(1.2);\r\n          transform: scale(1.2);\r\n}\r\n\r\n.footer .social i {\r\n  line-height: 25px;\r\n  font-size: 15px;\r\n}\r\n\r\n.footer .copy-right {\r\n  padding-top: 5rem;\r\n}\r\n\r\n.footer .copy-right span {\r\n  color: #85baac;\r\n}\r\n\r\n@media (max-width: 992px) {\r\n  .footer .follow-us {\r\n    width: 250px;\r\n    margin: 0 auto;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/anach/Desktop/tengtu-website/src/app/components/footer/footer.component.css
// module id = ../../../../../src/app/components/footer/footer.component.css
// module chunks = main